import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoicesComponent } from './invoices.component';
import { PageTitle } from '../store-front/misc/page-title/page-title.component';
import { AuthGuard, CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { FormErrorsModule } from '@spartacus/storefront';
import { ReactiveFormsModule } from '@angular/forms';
import { FormModule } from '@spartacus/organization/administration/components';
import { LocalLoaderComponent } from '../../../components/loader/local-loader/local-loader.component';
import { TableProComponent } from '../../../components/table-pro/table-pro.component';
import { DatePickerModule } from 'primeng/datepicker';
import { invoicesOccConfig } from './core/invoice.occ';
import { InvoiceService } from './core/invoice.service';
import { AllowedKeysToDatePickerModule } from '../../../core/directives/allowed-keys-to-date-picker/allowed-keys-to-date-picker.module';

@NgModule({
  declarations: [InvoicesComponent],
  imports: [
    CommonModule,
    PageTitle,
    I18nModule,
    FormModule,
    RouterModule,
    FormErrorsModule,
    DatePickerModule,
    ReactiveFormsModule,
    LocalLoaderComponent,
    TableProComponent,
    AllowedKeysToDatePickerModule,
  ],
  providers: [
    InvoiceService,
    provideConfig(<CmsConfig>{
      cmsComponents: {
        InvoicesPageComponent: {
          component: InvoicesComponent,
          guards: [AuthGuard],
        },
      },
    }),
    provideConfig(invoicesOccConfig),
    provideConfig({
      routing: {
        routes: {
          invoicesPage: { paths: ['my-account/invoices'] },
        },
      },
    }),
  ],
})
export class InvoicesModule {}
